<template>
  <b-row class="my-2">
    <b-col
      cols="3"
      class="d-flex align-items-center"
    >
      <b-badge
        variant="light"
        class="d-flex align-items-center w-100"
      >
        <font-awesome-icon
          :icon="['fal', 'image']"
          size="lg"
        />
        <span
          :class="iconClass"
          class="history-status"
        >
          {{ photoStatus }}
        </span>
      </b-badge>
    </b-col>
    <b-col
      cols="5"
      class="history-detail"
    >
      {{ comment }}
    </b-col>
    <b-col
      cols="2"
      class="history-user d-flex align-items-center"
    >
      {{ user }}
    </b-col>
    <b-col
      cols="2"
      class="history-date d-flex align-items-center"
    >
      {{ date }}
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    actionType: String,
    comment: String,
    user: String,
    date: String,
  },
  computed: {
    photoStatus() {
      return this.actionType === 'PHOTOSOL+' || this.actionType === 'PHOTOCLO+'
        ? this.$t('history.added')
        : this.$t('history.removed');
    },
    iconClass() {
      return this.actionType === 'PHOTOSOL+' || this.actionType === 'PHOTOCLO+'
        ? 'history-text-success'
        : 'history-text-primary';
    },
  },
};
</script>
